import React from "react";
import Layout from "../pages/Layout";
//import "bootstrap/dist/css/bootstrap.min.css";
import { Helmet } from "react-helmet";

const PrivacyPolicy = () => {
    return (
        <div>
            <Helmet>
              <title>Home - Factbazaar</title>
              <meta name="description" content="Learn how Factbazaar collects, uses, and protects your personal data. Read our Privacy Policy for more details." />
  <meta name="keywords" content="Privacy Policy, data protection, user rights, cookies policy, Factbazaar" />
  <meta name="author" content="Factbazaar Team" />
  <meta property="og:title" content="Privacy Policy - Factbazaar" />
  <meta property="og:description" content="Understand how we handle your personal information at Factbazaar. Read our Privacy Policy." />
  <meta property="og:type" content="website" />
  <meta property="og:url" content="https://www.factbazaar.com/privacy-policy" />
  <meta property="og:image" content="https://www.factbazaar.com/logo.png" />
            </Helmet>            
            <Layout>
        <div className="container my-5">
            <div className="text-center mb-5">
                {/* <h1 className="text-danger fw-bold">Privacy Policy</h1> */}
                <p className="lead text-muted">
                    Your privacy is important to us. This Privacy Policy explains how we collect, use, and protect your personal information.
                </p>
            </div>

            <div className="row justify-content-center">
                <div className="col-lg-8">
                    <div className="card shadow-sm border-0 mb-4">
                        <div className="card-body">
                            <h3 className="text-primary">Information We Collect</h3>
                            <ul className="list-group list-group-flush">
                                <li className="list-group-item">Your name, email, and contact details when you sign up.</li>
                                <li className="list-group-item">Usage data like page visits, IP addresses, and device information.</li>
                                <li className="list-group-item">Cookies and similar technologies for analytics and personalization.</li>
                            </ul>
                        </div>
                    </div>

                    <div className="card shadow-sm border-0 mb-4">
                        <div className="card-body">
                            <h3 className="text-primary">How We Use Your Information</h3>
                            <ul className="list-group list-group-flush">
                                <li className="list-group-item">To provide you with relevant news and updates.</li>
                                <li className="list-group-item">To improve our website experience and services.</li>
                                <li className="list-group-item">To send newsletters if you subscribe.</li>
                                <li className="list-group-item">To comply with legal requirements.</li>
                            </ul>
                        </div>
                    </div>

                    <div className="card shadow-sm border-0 mb-4">
                        <div className="card-body">
                            <h3 className="text-primary">Your Rights</h3>
                            <p>
                                You have the right to request access to your data, ask for corrections, or request deletion of your personal information.
                                 <a href="mailto:support@factbazaar.com" className="text-decoration-none"> Contact us</a> for any concerns.
                            </p>
                        </div>
                    </div>

                    <div className="card shadow-sm border-0 mb-4">
                        <div className="card-body">
                            <h3 className="text-primary">Cookies Policy</h3>
                            <p>
                                We use cookies to improve user experience. You can disable cookies in your browser settings, but some features may not function properly.
                            </p>
                        </div>
                    </div>

                    <div className="card shadow-sm border-0">
                        <div className="card-body">
                            <h3 className="text-primary">Changes to This Policy</h3>
                            <p>
                                We may update this Privacy Policy from time to time. Any changes will be posted here, so please review periodically.
                            </p>
                        </div>
                    </div>
                </div>
            </div>

           
        </div>
        </Layout>
    </div>
    );
};

export default PrivacyPolicy;